import React, { useMemo, useState, useEffect, useCallback } from 'react';
import { Spin } from 'antd';
import lodashGet from 'lodash/get';
import classNames from 'classnames';
import { isObject } from 'lodash';
import { FLOLDER, FolderId2NameMap } from '@web-mail/common/constant';
import cloneDeep from 'lodash/cloneDeep';
import SearchOutlined from '@ant-design/icons/SearchOutlined';
import IconCard from '@web-common/components/UI/IconCard';
import { apiHolder as api, apis } from 'api';
import { SearchLoading } from '@web-common/components/UI/SearchLoading/searchLoading';
import SiriusCollapse from '@web-mail/components/SiriusCollapse';
import { getChildTreeByRule, SEARCH_RESULT_STATS_ORDER } from '../../util';
import useState2RM from '../../hooks/useState2ReduxMock';
import SearchResultTree from './SearchResultTree';
import { getIn18Text } from 'api';
import { ReactComponent as TongyongQuanbu2 } from '@/images/icons/common/all.svg';
const accountApi = api.api.requireLogicalApi(apis.accountApiImpl);
const SearchResult = props => {
    const { handleSwitchFolder, expandFolder, reSearch, onSeverSearch, onSeverSearchMoreAccounts } = props;
    const [searchSelected] = useState2RM('searchListStateTab', 'doUpdateSearchListStateTab');
    const [mailSearchStateMap, doUpdateMailSearchStateMap] = useState2RM('mailSearchStateMap', 'doUpdateMailSearchStateMap');
    const [mailSearching] = useState2RM('mailSearching', 'doUpdateMailSearching');
    const [mailSearchMoreAccounts, setMailSearchMoreAccounts] = useState2RM('mailSearchMoreAccounts', 'doUpdateMailSearchMoreAccounts');
    const isSearching = useMemo(() => !!mailSearching, [mailSearching]);
    const isAdvancedSearch = useMemo(() => mailSearching === 'advanced', [mailSearching]);
    const [advanceSearchFromValues] = useState2RM('advanceSearchFromValues', 'doUpdateAdvanceSearchFromValues');
    const [listLoading] = useState2RM('listLoading', 'doUpdateMailListLoading');
    const [mailSearchAccount, doUpdateMailSearchAccount] = useState2RM('mailSearchAccount', 'doUpdateMailSearchAccount');
    const [selectedSearchKeys, setSelectedSearchKeys] = useState2RM('selectedSearchKeys', 'doUpdateSelectedSearchKey');
    const [searchResultObj, setSearchResultObj] = useState2RM('searchResultObj', 'doUpdateSearchResultObj');
    const [searchLoading] = useState2RM('searchLoading', 'doUpdateMailSearchLoading');
    const [defaultSelectedSearchKeyMap, doUpdateDefaultSelectedSearchKeyMap] = useState2RM('defaultSelectedSearchKeyMap', 'doUpdateDefaultSelectedSearchKeyMap');
    const [searchResultList, setSearchResultList] = useState([]);
    const [intermediateKey, setIntermediateKey] = useState([]);
    const [totalAccount, setTotalAccount] = useState([]);
    const [searchResultMoreAccountsNum, setSearchResultMoreAccountsNum] = useState(0);
    const siriusCollapseRef = React.useRef(null);
    const getTotalAccount = async () => {
        const totalAccounts = ((await accountApi.getMainAndSubAccounts({ expired: false })) || []).map(item => ({
            key: item.id,
            value: item.agentEmail,
            keyType: item.emailType,
        }));
        setTotalAccount(totalAccounts);
    };
    useEffect(() => {
        if (isSearching) {
            getTotalAccount();
        }
        else {
            setSearchResultList([]);
            setIntermediateKey([]);
            setTotalAccount([]);
        }
    }, [isSearching]);
    useEffect(() => {
        if (Object.keys(defaultSelectedSearchKeyMap).length === 0) {
            return;
        }
        const keys = [];
        for (const key in defaultSelectedSearchKeyMap) {
            if (!defaultSelectedSearchKeyMap[key].resetDisable) {
                keys.push(key);
            }
        }
        setIntermediateKey(keys);
    }, [defaultSelectedSearchKeyMap]);
    const beforeSeverSearch = (email) => {
        resetCurrentMailList(email, 'server');
        onSeverSearch(email);
    };
    const resetCurrentMailList = (email, type) => {
        const current = searchResultList.find(item => (item === null || item === void 0 ? void 0 : item.key) === email);
        const currentIndex = searchResultList.findIndex(item => (item === null || item === void 0 ? void 0 : item.key) === email);
        const cloneSearchResultList = cloneDeep(searchResultList);
        cloneSearchResultList.splice(currentIndex, 1, {
            key: current.key,
            title: current.title,
            type: current.type,
            count: '',
            children: renderLoading(current.key, type),
        });
        setSearchResultList(cloneSearchResultList);
    };
    const searchCloud = (email) => mailSearchStateMap[email] === 'local' ? (React.createElement("div", { className: "m-filter-type" },
        React.createElement("p", { className: "m-filter-type-desc" }, getIn18Text('MEIZHAODAOXIANG')),
        React.createElement("p", { className: "m-filter-type-change" },
            getIn18Text('KECHANGSHI'),
            React.createElement("span", { onClick: () => beforeSeverSearch(email) },
                getIn18Text('SOUSUOQUANBUYUN'),
                React.createElement(SearchOutlined, null))))) : null;
    const renderLoading = (email, type) => {
        const stype = type || mailSearchStateMap[email];
        const searchStr = getIn18Text('SOUSUOZHONG');
        const normalSearch = process.env.BUILD_ISWEB || process.env.BUILD_ISEDM;
        const isExplictLocalSearch = !stype || stype === 'local';
        const isExplictCloudSearch = stype === 'server';
        const text = normalSearch ? searchStr : `${isExplictLocalSearch ? getIn18Text('BENDISOUSZ') : ''}${isExplictCloudSearch ? getIn18Text('YUNDUANSOUSUOZHONG') : ''}`;
        return (React.createElement("div", { className: "u-item-loading" },
            React.createElement(SearchLoading, { height: 14, text: text, size: 14, textStyle: { fontSize: 12, margin: 0 } })));
    };
    const renderEmpty = (email) => (React.createElement(React.Fragment, null,
        searchCloud(email),
        React.createElement("div", { className: "m-filter-wrapper" },
            React.createElement("p", { className: "m-filter-empty" }, getIn18Text('WUSOUSUOJIEGUO')))));
    const renderItem = (data, email, disable) => {
        return (React.createElement("div", { className: "m-filter-wrapper" },
            React.createElement("div", { className: "m-filter-scope" },
                React.createElement("span", { className: "m-filter-scope-explain" }, getIn18Text('SHAIXUANFANW')),
                React.createElement("span", { className: `m-filter-scope-reset ${disable ? 'm-filter-scope-reset-disable' : ''}`, onClick: () => !disable && resetSearch(email) },
                    React.createElement("span", null, getIn18Text('ZHONGZHI')),
                    React.createElement(IconCard, { type: "resetSearch", stroke: disable ? '#a8aaad' : '' }))),
            React.createElement(SearchResultTree, { data: data, email: email, handleSwitchFolder: handleSwitchFolder, expandFolder: expandFolder })));
    };
    const getResult = useCallback(() => {
        const selectedSearchKeyMap = cloneDeep(defaultSelectedSearchKeyMap);
        const displayAccount = isAdvancedSearch ? totalAccount.filter(item => item.key === mailSearchAccount) : totalAccount;
        const resultList = displayAccount.map(item => {
            var _a, _b, _c;
            const email = item.key;
            const emailValue = item.value;
            if (email !== searchResultObj._account) {
                const current = searchResultList.find(item => (item === null || item === void 0 ? void 0 : item.key) === email);
                return (current === null || current === void 0 ? void 0 : current.key)
                    ? current
                    : {
                        key: email,
                        title: emailValue,
                        type: item.keyType,
                        count: '',
                        children: renderLoading(email),
                    };
            }
            const currentFid = searchResultObj.fid || FLOLDER.SEARCH_ALL_RESULT;
            const selectFid = +(((_a = selectedSearchKeys[email]) === null || _a === void 0 ? void 0 : _a.folder) || FLOLDER.SEARCH_ALL_RESULT);
            const currentFilterCond = searchResultObj.filterCond || [];
            const totalSelect = cloneDeep(selectedSearchKeys[email] || {});
            for (const k in totalSelect) {
                if (k === 'folder' || totalSelect[k].operand === 'all') {
                    delete totalSelect[k];
                }
            }
            const selectFilterCond = Object.values(totalSelect);
            let correct = true;
            try {
                correct = currentFid === selectFid && JSON.stringify(currentFilterCond) === JSON.stringify(selectFilterCond);
            }
            catch (e) {
                correct = false;
            }
            if (!correct) {
                return;
            }
            const searchTotal = searchResultObj.total;
            const filterSearchTreeRes = filterSearchTree(searchResultObj.folders);
            let filterFolders = Array.isArray(filterSearchTreeRes) ? filterSearchTreeRes : [filterSearchTreeRes];
            filterFolders = filterFolders.map(folder => {
                return Object.assign(Object.assign({}, folder), { entry: Object.assign(Object.assign({}, folder.entry), { mailBoxName: FolderId2NameMap[folder.entry.mailBoxId] || folder.entry.mailBoxName }) });
            });
            const isAllEmpty = isSearchTreeEmpty(filterFolders);
            const notEmptyFilterFolders = filterFolders.filter(item => lodashGet(item, 'entry.mailBoxUnread', 0) !== 0);
            if (notEmptyFilterFolders.length === 2) {
                filterFolders = [notEmptyFilterFolders[1]];
            }
            const result = [
                {
                    key: 'folder',
                    name: getIn18Text('WENJIANJIA'),
                    item: filterFolders,
                },
            ];
            const defaultFolderId = (filterFolders.length === 1 ? (_b = filterFolders[0]) === null || _b === void 0 ? void 0 : _b.mailBoxId : FLOLDER.SEARCH_ALL_RESULT) + '';
            let resetDisable = true;
            if (((_c = selectedSearchKeys[email]) === null || _c === void 0 ? void 0 : _c.folder) && selectedSearchKeys[email].folder !== defaultFolderId) {
                resetDisable = false;
            }
            selectedSearchKeyMap[email] = {
                folder: defaultFolderId,
                resetDisable,
            };
            SEARCH_RESULT_STATS_ORDER.forEach(key1 => {
                var _a, _b, _c, _d;
                const searchStatsObj = searchResultObj.stats;
                if (!searchStatsObj || !searchStatsObj[key1]) {
                    return;
                }
                if (isAdvancedSearch && key1 === 'fromAddress') {
                    const fv = advanceSearchFromValues || {};
                    if (fv.from) {
                        return;
                    }
                }
                const item = cloneDeep(searchStatsObj[key1].items);
                let itemCount = 0;
                for (const key2 in item) {
                    if ((((_a = item[key2]) === null || _a === void 0 ? void 0 : _a.value) || 0) === 0) {
                        delete item[key2];
                    }
                    else {
                        if ((key1 === 'sentDate' && ['三月内', '三月前'].includes((_b = item[key2]) === null || _b === void 0 ? void 0 : _b.label)) || key1 !== 'sentDate') {
                            itemCount += (_c = item[key2]) === null || _c === void 0 ? void 0 : _c.value;
                        }
                    }
                }
                const statsKeys = Object.keys(item);
                const filterStats = statsKeys.length === 1
                    ? Object.assign({}, item) : Object.assign({ all: {
                        filterCond: { operand: 'all' },
                        key: 'all',
                        label: getIn18Text('QUANBU'),
                        value: itemCount,
                    } }, item);
                const defaultStatsKey = statsKeys.length === 1 ? statsKeys[0] : 'all';
                if (selectedSearchKeys[email] && ((_d = selectedSearchKeys[email][key1]) === null || _d === void 0 ? void 0 : _d.operand)) {
                    if (isObject(selectedSearchKeys[email][key1].operand)) {
                        if (Object.values(selectedSearchKeys[email][key1].operand)[0] + '' !== defaultStatsKey) {
                            selectedSearchKeyMap[email].resetDisable = false;
                        }
                    }
                    else if (selectedSearchKeys[email][key1].operand !== defaultStatsKey) {
                        selectedSearchKeyMap[email].resetDisable = false;
                    }
                }
                selectedSearchKeyMap[email][key1] = defaultStatsKey;
                result.push({
                    key: key1,
                    name: searchStatsObj[key1].name,
                    item: filterStats,
                });
            });
            return {
                key: email,
                title: emailValue,
                count: searchTotal,
                type: item.keyType,
                children: (!isAdvancedSearch && (Object.keys(selectedSearchKeyMap[email]).length > 2 || searchResultObj.fid)) || (isAdvancedSearch && (searchTotal > 0 || !isAllEmpty))
                    ? renderItem(result, email, !!selectedSearchKeyMap[email].resetDisable)
                    : renderEmpty(email),
            };
        });
        return {
            resultList,
            selectedSearchKeyMap,
        };
    }, [isAdvancedSearch, selectedSearchKeys, defaultSelectedSearchKeyMap, totalAccount, searchResultList, searchResultObj, mailSearchAccount]);
    useEffect(() => {
        const resultList = totalAccount.map(item => ({
            key: item.key,
            title: item.value,
            type: item.keyType,
            count: '',
            children: renderLoading(item.key),
        }));
        setSearchResultList(resultList);
    }, [totalAccount]);
    useEffect(() => {
        if (totalAccount.length === 0) {
            return;
        }
        if (mailSearchMoreAccounts && !isAdvancedSearch) {
            setSearchResultMoreAccountsNum(searchResultObj.total);
            return;
        }
        if ((!mailSearchStateMap[mailSearchAccount] || mailSearchStateMap[mailSearchAccount] === 'local') &&
            searchResultObj.total === 0 &&
            (!searchResultObj.fid || searchResultObj.fid < 100) &&
            searchSelected === 'ALL') {
            onSeverSearch(mailSearchAccount);
            return;
        }
        const { resultList, selectedSearchKeyMap } = getResult();
        doUpdateDefaultSelectedSearchKeyMap(selectedSearchKeyMap);
        setSearchResultList(resultList);
    }, [searchResultObj, totalAccount.length]);
    const filterSearchTree = (data) => getChildTreeByRule(data, (folder) => folder);
    const isSearchTreeEmpty = (data) => {
        const notEmpty = data.some(item => {
            if (item.entry.mailBoxUnread !== 0) {
                return true;
            }
            else if (item.children && item.children.length) {
                return !isSearchTreeEmpty(item.children);
            }
            else {
                return false;
            }
        });
        return !notEmpty;
    };
    const resetSearch = (key, loading) => {
        setMailSearchMoreAccounts(false);
        if (loading) {
            resetCurrentMailList(key);
        }
        doUpdateMailSearchAccount(key);
        doUpdateDefaultSelectedSearchKeyMap({});
        setIntermediateKey([]);
        setSelectedSearchKeys({});
        reSearch(key);
    };
    const handleSearchMailMoreAccounts = () => {
        var _a;
        (_a = siriusCollapseRef.current) === null || _a === void 0 ? void 0 : _a.closeAll();
        if (mailSearchMoreAccounts) {
            return;
        }
        else {
            setMailSearchMoreAccounts(true);
            onSeverSearchMoreAccounts && onSeverSearchMoreAccounts();
        }
    };
    const searchResultMoreAccounts = useMemo(() => {
        if (totalAccount.length > 1 && !searchLoading && !isAdvancedSearch) {
            return (React.createElement("div", { className: classNames('search-result-more-accounts', { 'search-result-more-accounts-selected': mailSearchMoreAccounts }), onClick: handleSearchMailMoreAccounts },
                React.createElement(TongyongQuanbu2, { style: { marginLeft: 29, marginRight: 8 } }),
                React.createElement("span", { style: { flex: 1 } }, getIn18Text('QUANBUSOUSJG')),
                searchResultMoreAccountsNum > 0 && React.createElement("span", { style: { marginRight: 14 } }, searchResultMoreAccountsNum)));
        }
        else {
            return null;
        }
    }, [totalAccount.length, searchResultMoreAccountsNum, mailSearchMoreAccounts, searchLoading, isAdvancedSearch]);
    return (React.createElement(Spin, { spinning: listLoading && isAdvancedSearch },
        React.createElement("div", { className: "search-result-wrap" },
            searchResultMoreAccounts,
            React.createElement(SiriusCollapse, { ref: siriusCollapseRef, intermediateKey: intermediateKey, single: true, showTooltip: true, operateSeparate: true, dataList: searchResultList, searchAccount: !mailSearchMoreAccounts ? mailSearchAccount : undefined, defaultActiveKey: !mailSearchMoreAccounts ? [mailSearchAccount] : [], activeKey: !mailSearchMoreAccounts ? [mailSearchAccount] : undefined, resetSearch: resetSearch, collapseStyle: { visibility: isAdvancedSearch ? (listLoading ? 'hidden' : 'visible') : searchLoading ? 'hidden' : 'visible' } }))));
};
export default SearchResult;
